import { render, staticRenderFns } from "./StyledModalForm.vue?vue&type=template&id=71c51167"
import script from "./StyledModalForm.vue?vue&type=script&lang=js"
export * from "./StyledModalForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports